import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import DanhMucPage from './pages/DanhMucPage';
import PhanCongPage from './pages/PhanCongPage';
import TKBPage from './pages/TKBPage';
import KetQuaTKBPage from './pages/KetQuaTKBPage';
import ProfilePage from './pages/ProfilePage';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Đang tải...</p>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/" />;
};

// Public Route Component (redirect if already logged in)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Đang tải...</p>
      </div>
    );
  }
  
  return !isAuthenticated ? children : <Navigate to="/dashboard" />;
};

function App() {
  return (
    <Routes>
      {/* Landing — trước khi đăng nhập */}
      <Route path="/" element={
        <PublicRoute>
          <LandingPage />
        </PublicRoute>
      } />

      {/* Public Routes */}
      <Route path="/login" element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      } />
      <Route path="/register" element={
        <PublicRoute>
          <Register />
        </PublicRoute>
      } />

      {/* Protected Routes */}
      <Route element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="danh-muc" element={<DanhMucPage />} />
        <Route path="khoi" element={<Navigate to="/danh-muc" replace />} />
        <Route path="lop-hoc" element={<Navigate to="/danh-muc" replace />} />
        <Route path="mon-hoc" element={<Navigate to="/danh-muc" replace />} />
        <Route path="giao-vien" element={<Navigate to="/danh-muc" replace />} />
        <Route path="phan-cong" element={<PhanCongPage />} />
        <Route path="tkb" element={<TKBPage />} />
        <Route path="ket-qua-tkb" element={<KetQuaTKBPage />} />
        <Route path="profile" element={<ProfilePage />} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
